<dialog
  #practiceUsersDialog
  qai-dialog
  (closeButtonClicked)="handleCloseModal()"
>
  <app-practice-users
    [isUserModalOpen]="openUserModal"
    [pageSize]="10"
    [moduleAssignmentUuid]="moduleAssignmentUuid"
    [teamUuids]="teamUuids"
    [engagementStatus]="engagementStatus"
    [userData]="userData"
    [isLoadingData]="isLoadingData"
    (closeUserModal)="handleCloseModal()"
    [assignmentName]="assignmentName"
  ></app-practice-users>
</dialog>
